// import React, { useEffect, useState } from "react";
// import logo from "../assets/logo.jpg";

// /* ================= HELPER FUNCTIONS ================= */
// const toMarathi = async (text) => {
//   if (!text) return "";
//   try {
//     const res = await fetch(
//       `https://inputtools.google.com/request?text=${encodeURIComponent(text)}&itc=mr-t-i0-und&num=1`
//     );
//     const data = await res.json();
//     return data[0] === "SUCCESS" ? data[1][0][1][0] : text;
//   } catch {
//     return text;
//   }
// };

// const formatDate = (date) => {
//   if (!date) return "";
//   const d = new Date(date);
//   const day = String(d.getDate()).padStart(2, "0");
//   const month = String(d.getMonth() + 1).padStart(2, "0");
//   const year = d.getFullYear();
//   return `${day}/${month}/${year}`;
// };

// // const toMarathiNumber = (num) => {
// //   return num?.toString().replace(/\d/g, (d) => "०१२३४५६७८९"[d]) || "";
// // };

// const DeveloperChargesPrint = ({ data = {}, onClose }) => {
//   const mode = data.mode || "EN";

//   const [mrData, setMrData] = useState({});
//   const [ready, setReady] = useState(false);

//   const copies = [
//     "Receipt (Copy for Department)",
//     "Receipt (Copy for Developer)",
//     "Receipt (Office Copy)",
//   ];

//   const copiesMR = [
//     "पावती (विभागासाठी प्रत)",
//     "पावती (विकसकासाठी प्रत)",
//     "पावती (कार्यालयीन प्रत)",
//   ];

//   /* ================= MARATHI CONVERSION ================= */
//   useEffect(() => {
//     if (mode === "MR") {
//       const convert = async () => {
//         const converted = {
//           developer_name: await toMarathi(data.developer_name || ""),
//           bank_name: await toMarathi(data.bank_name || ""),
//           fee_description: await toMarathi(data.fee_description || ""),
//           scheme_details: await toMarathi(data.scheme_details || ""),
//           amount_words: await toMarathi(data.amount_words || ""),
//           challan_no: await toMarathi(data.challan_no || ""),
//           account_no: await toMarathi(data.account_no || ""),
//           proposal_no: await toMarathi(data.proposal_no || ""),
//           dd_cheque_number: await toMarathi(data.dd_cheque_number || ""),
//           receipt_date: await toMarathi(formatDate(data.receipt_date)),
//         };
//         setMrData(converted);
//         setReady(true);
//       };
//       convert();
//     } else {
//       setReady(true);
//     }
//   }, [data, mode]);

//   /* ================= AUTO PRINT ================= */
//   useEffect(() => {
//     if (ready) {
//       setTimeout(() => {
//         window.print();
//         // onClose?.();
//       }, 600);
//     }
//   }, [ready, onClose]);

//   if (!ready) return null;

//   return (
//     <div className="print-container">
//       {/* ================= RECEIPTS ================= */}
//       <div className=" receipt-page">
//         {(mode === "EN" ? copies : copiesMR).map((title, index) => (
//           <div key={index} className="receipt">

//             <div className="receipt-header">
//               <img src={logo} alt="logo" className="logo" />
//               {mode === "EN" ? (
//                 <>
//                   <h2>Slum Rehabilitation Authority</h2>
//                   <h2>Dharavi Redevelopment Project</h2>
//                   <p>
//                     4th Floor, Gala Altazza, Udyog Nagar, Flank Road,<br />
//                     Beside Shanmukhanand Auditorium, Kings Circle, Sion, Mumbai-400022
//                   </p>
//                 </>
//               ) : (
//                 <>
//                   <h2>झोपडपट्टी पुनर्वसन प्राधिकरण</h2>
//                   <h2>धारावी पुनर्विकास प्रकल्प</h2>
//                   <p>
//                     चौथा मजला, गाला अल्टाझा, उद्योग नगर, फ्लँक रोड,<br />
//                     शनमुखानंद सभागृहाजवळ, किंग्ज सर्कल, सायन, मुंबई-४०००२२
//                   </p>
//                 </>
//               )}
//             </div>

//             <div className="receipt-title">{title}</div>

//             <div className="receipt-body">
//               <div className="left">
//                 <div className="row">
//                   <b>{mode === "EN" ? "Receipt No:" : "पावती क्रमांक:"}</b>{" "}
//                   {data.receipt_no || "-"}
//                 </div>
//                 <div className="row">
//                   <b>{mode === "EN" ? "Developer:" : "विकसक:"}</b>{" "}
//                   {mode === "EN" ? data.developer_name : mrData.developer_name}
//                 </div>
//                 <div className="row">
//                   <b>{mode === "EN" ? "Amount in Words:" : "रक्कम (शब्दात):"}</b>{" "}
//                   {mode === "EN" ? data.amount_words : mrData.amount_words}
//                 </div>
//                 <div className="row">
//                   <b>{mode === "EN" ? "Fees Type Description:" : "शुल्क प्रकार वर्णन:"}</b>{" "}
//                   {mode === "EN" ? data.fee_description : mrData.fee_description}
//                 </div>
//                 <div className="row">
//                   <b>{mode === "EN" ? "Scheme Details:" : "योजना :"}</b>{" "}
//                   {mode === "EN" ? data.scheme_details_extra : mrData.scheme_details}
//                 </div>
//                 <div className="row"><b>By DD/Cheque</b></div>
//                 <div className="row">
//                   <b>{mode === "EN" ? "Bank Name:" : "बँकेचे नाव:"}</b>{" "}
//                   {mode === "EN" ? data.bank_name : mrData.bank_name}
//                 </div>
//                 <div className="row">
//                   <b>Remarks:</b> Developer Charges Receipt
//                 </div>

//                 <div className="amount-box">
//                   Rs.{data.amount || "0"}/-
//                 </div>
//               </div>

//               <div className="right">
//                 <div className="row">
//                   <b>{mode === "EN" ? "Receipt Dt:" : "पावती दिनांक:"}</b>{" "}
//                   {mode === "EN" ? formatDate(data.receipt_date) : mrData.receipt_date}
//                 </div>
//                 <div className="row"><b>Challan No:</b> {data.challan_no || "-"}</div>
//                 <div className="row"><b>A/C No:</b> {data.account_no || "-"}</div>
//                 <div className="row"><b>Amount:</b> Rs.{data.amount || "0"}/-</div>
//                 <div className="row"><b>Proposal No:</b> {data.proposal_no || "-"}</div>
//                 <div className="row"><b>DD No:</b> {data.dd_cheque_number || "-"}</div>
//                 <div className="row">
//                   <b>Cheque/DD Date:</b>{" "}
//                   {mode === "EN" ? formatDate(data.receipt_date) : mrData.receipt_date}
//                 </div>
//               </div>
//             </div>

//             <div className="receipt-footer">
//               <div className="signature-space"></div>
//               {mode === "EN"
//                 ? "Slum Rehabilitation Authority / DRP, Mumbai."
//                 : "झोपडपट्टी पुनर्वसन प्राधिकरण / डीआरपी, मुंबई."}
//             </div>
//           </div>
//         ))}
//       </div>

    
//     </div>
//   );
// };

// export default DeveloperChargesPrint;


import React, { useEffect, useState, useRef } from "react";
import logo from "../assets/logo.jpg";
import { translateToMarathi } from "../utils/marathiTranslator";
/* ================= HELPER FUNCTIONS ================= */
const toMarathi = async (text) => {
  if (!text) return "";
  try {
    const res = await fetch(
      `https://inputtools.google.com/request?text=${encodeURIComponent(text)}&itc=mr-t-i0-und&num=1`
    );
    const data = await res.json();
    if (data?.[0] === "SUCCESS" && data?.[1]?.[0]?.[1]?.[0]) {
      return data[1][0][1][0];
    }
    return text;
  } catch (err) {
    console.error("toMarathi failed:", text, err);
    return text;
  }
};

const toMarathiNumber = (num) => {
  if (num == null) return "";
  return num.toString().replace(/\d/g, (d) => "०१२३४५६७८९"[d]);
};

const toMarathiDate = (dateStr) => {
  if (!dateStr) return "";
  return dateStr.toString().replace(/\d/g, (d) => "०१२३४५६७८९"[d]);
};

/* ================= IMPROVED MARATHI NUMBER TO WORDS ================= */
const numberToMarathiWords = (num) => {
  if (!num || isNaN(num) || num <= 0) return "शून्य";

  const belowTwenty = [
    "", "एक", "दोन", "तीन", "चार", "पाच", "सहा", "सात", "आठ", "नऊ", "दहा",
    "अकरा", "बारा", "तेरा", "चौदा", "पंधरा", "सोळा", "सतरा", "अठरा", "एकोणीस"
  ];

  const tens = [
    "", "", "वीस", "तीस", "चाळीस", "पन्नास", "साठ", "सत्तर", "ऐशी", "नव्वद"
  ];

  const specialTens = {
    21: "एकवीस", 22: "बावीस", 23: "तेवीस", 24: "चोवीस", 25: "पंचवीस",
    26: "सव्वीस", 27: "सत्तावीस", 28: "अठ्ठावीस", 29: "एकोणतीस",
    31: "एकतीस", 32: "बत्तीस", 33: "तेहतीस", 34: "चौतीस", 35: "पस्तीस",
    36: "छत्तीस", 37: "सदतीस", 38: "अडतीस", 39: "एकोणचाळीस",
    41: "एकेचाळीस", 42: "बेचाळीस", 43: "त्रेचाळीस", 44: "चव्वेचाळीस",
    45: "पंचेचाळीस", 46: "सदेचाळीस", 47: "सत्तेचाळीस", 48: "अठ्ठेचाळीस", 49: "एकोणपन्नास"
  };

  const hundreds = [
    "", "एकशे", "दोनशे", "तीनशे", "चारशे", "पाचशे", "सहाशे", "सातशे", "आठशे", "नऊशे"
  ];

  const scales = ["", "हजार", "लाख", "कोटी"];

  const convertLessThanThousand = (n) => {
    if (n === 0) return "";
    if (n < 20) return belowTwenty[n];

    // Special numbers like 21-29, 31-39 etc.
    if (specialTens[n]) return specialTens[n];

    if (n < 100) {
      const ten = Math.floor(n / 10);
      const rem = n % 10;
      let str = tens[ten];
      if (rem > 0) str += " " + belowTwenty[rem];
      return str;
    }

    const hundred = Math.floor(n / 100);
    const rem = n % 100;
    let result = hundreds[hundred];
    if (rem > 0) result += " " + convertLessThanThousand(rem);
    return result;
  };

  let result = "";
  let scaleIndex = 0;
  let tempNum = Math.floor(Math.abs(Number(num)));

  while (tempNum > 0) {
    const chunk = scaleIndex === 0 ? tempNum % 1000 : tempNum % 100;
    tempNum = scaleIndex === 0 ? Math.floor(tempNum / 1000) : Math.floor(tempNum / 100);

    if (chunk > 0) {
      let chunkWords = convertLessThanThousand(chunk);
      if (scaleIndex > 0) chunkWords += " " + scales[scaleIndex];
      result = chunkWords + (result ? " " + result : "");
    }
    scaleIndex++;
    if (scaleIndex > 3) break;
  }

  return result.trim() + " रुपये";
};


/* ================= MAIN COMPONENT ================= */
const DeveloperChargesPrint = ({ data = {}, onClose }) => {
  const [mrData, setMrData] = useState({});
  const [ready, setReady] = useState(false);
 const hasPrinted = useRef(false);   // ← ADD THIS LINE

  const mode = data.mode || "EN";

  const copiesEN = ["Receipt (Copy for Department)", "Receipt (Copy for Developer)", "Receipt (Office Copy)"];
  const copiesMR = ["पावती (विभागासाठी प्रत)", "पावती (विकसकासाठी प्रत)", "पावती (कार्यालयीन प्रत)"];

  const formatDate = (date) => {
    if (!date) return "";
    const d = new Date(date);
    return `${String(d.getDate()).padStart(2, "0")}/${String(d.getMonth() + 1).padStart(2, "0")}/${d.getFullYear()}`;
  };

  useEffect(() => {
    const convert = async () => {
      if (mode !== "MR") {
        setReady(true);
        return;
      }

      try {
        const amountInMarathi = numberToMarathiWords(data.amount);

        const converted = {
          developer_name: await toMarathi(data.developer_name || ""),
          // 🔥 Only bank_name uses custom translator
          bank_name: translateToMarathi(data.bank_name || ""),
          fee_description: await toMarathi(data.fee_description || ""),
         scheme_details: await toMarathi(data.scheme_details_extra || ""),
          challan_no: await toMarathi(data.challan_no || ""),
          account_no: await toMarathi(data.account_no || ""),
          proposal_no: await toMarathi(data.proposal_no || ""),
          dd_cheque_number: await toMarathi(data.dd_cheque_number || ""),
          receipt_date: toMarathiDate(formatDate(data.receipt_date)),
          amount_words_marathi: amountInMarathi,
         remarks: await toMarathi(data.remark || ""),
        };

        setMrData(converted);
        console.log("✅ Marathi Conversion Done", converted);
      } catch (err) {
        console.error("Conversion error:", err);
      } finally {
        setReady(true);
      }
    };

    convert();
  }, [data, mode]);

 useEffect(() => {
  console.log("🖨️ print useEffect fired, ready:", ready, "hasPrinted:", hasPrinted.current);
  if (!ready) return;
  if (hasPrinted.current) return;
  hasPrinted.current = true;
  setTimeout(() => window.print(), 600);
}, [ready]);
  if (!ready) return null;

  return (
    <div className="print-container">
      <div className="receipt-page">
        {(mode === "EN" ? copiesEN : copiesMR).map((title, index) => (
          <div key={index} className="receipt">
            {/* Header */}
            <div className="receipt-header">
              <img src={logo} alt="logo" className="logo" />
              {mode === "EN" ? (
                <>
                  <h2>Slum Rehabilitation Authority</h2>
                  <h2>Dharavi Redevelopment Project</h2>
                  <p>4th Floor, Gala Altazza, Udyog Nagar, Flank Road,<br />
                     Beside Shanmukhanand Auditorium, Kings Circle, Sion, Mumbai-400022</p>
                </>
              ) : (
                <>
                  <h2>झोपडपट्टी पुनर्वसन प्राधिकरण</h2>
                  <h2>धारावी पुनर्विकास प्रकल्प</h2>
                  <p>चौथा मजला, गाला अल्टाझा, उद्योग नगर, फ्लँक रोड,<br />
                     शनमुखानंद सभागृहाजवळ, किंग्ज सर्कल, सायन, मुंबई-४०००२२</p>
                </>
              )}
            </div>

            <div className="receipt-title">{title}</div>

            <div className="receipt-body">
              <div className="left">
                <div className="row"><b>{mode === "EN" ? "Receipt No:" : "पावती क्रमांक:"}</b> {mode === "EN" ? data.receipt_no : toMarathiNumber(data.receipt_no)}</div>
                <div className="row"><b>{mode === "EN" ? "Developer:" : "विकसक:"}</b> {mode === "EN" ? data.developer_name : mrData.developer_name}</div>
                <div className="row"><b>{mode === "EN" ? "Amount in Words:" : "रक्कम (शब्दात):"}</b> {mode === "EN" ? data.amount_words : mrData.amount_words_marathi}</div>
                <div className="row"><b>{mode === "EN" ? "Fees Type Description:" : "शुल्क प्रकार वर्णन:"}</b> {mode === "EN" ? data.fee_description : mrData.fee_description}</div>
              <div className="row">
  <b>{mode === "EN" ? "Scheme Details:" : "योजना :"}</b>
  {mode === "EN"
    ? data.scheme_details_extra
    : mrData.scheme_details}
</div>
                <div className="row">
  <b>{mode === "EN" 
    ? `By ${data.payment_mode || "DD/Cheque"}` 
    : `${data.payment_mode === "RTGS" ? "आरटीजीएस द्वारे" : data.payment_mode === "NEFT" ? "एनईएफटी द्वारे" : data.payment_mode === "Cash" ? "रोख द्वारे" : "डीडी/चेकद्वारे"}`}
  </b>
</div>
                <div className="row"><b>{mode === "EN" ? "Bank Name:" : "बँकेचे नाव:"}</b> {mode === "EN" ? data.bank_name : mrData.bank_name}</div>
              <div className="row">
  <b>{mode === "EN" ? "Remarks:" : "नोंद:"}</b>{" "}
  {mode === "EN" ? data.remark : mrData.remarks}
</div>
                <div className="amount-box">
                  {mode === "EN" ? `Rs.${data.amount}/-` : `₹${toMarathiNumber(data.amount)}/-`}
                </div>
              </div>

              <div className="right">
                <div className="row"><b>{mode === "EN" ? "Receipt Dt:" : "पावती दिनांक:"}</b> {mode === "EN" ? formatDate(data.receipt_date) : mrData.receipt_date}</div>
                <div className="row"><b>Challan No:</b> {mode === "EN" ? data.challan_no : toMarathiNumber(data.challan_no)}</div>
                <div className="row"><b>A/C No:</b> {mode === "EN" ? data.account_no : toMarathiNumber(data.account_no)}</div>
                <div className="row"><b>Amount:</b> {mode === "EN" ? `Rs.${data.amount}/-` : `₹${toMarathiNumber(data.amount)}/-`}</div>
                <div className="row"><b>Proposal No:</b> {mode === "EN" ? data.proposal_no : toMarathiNumber(data.proposal_no)}</div>
                <div className="row">
  <b>{data.payment_mode === "RTGS" || data.payment_mode === "NEFT" ? `${data.payment_mode} Ref No:` : "DD No:"}</b>{" "}
  {mode === "EN" ? data.dd_cheque_number : toMarathiNumber(data.dd_cheque_number)}
</div>
          <div className="row">
  <b>
    {data.payment_mode === "RTGS"
      ? "RTGS Date:"
      : data.payment_mode === "NEFT"
      ? "NEFT Date:"
      : data.payment_mode === "Cash"
      ? "Cash Date:"
      : "Cheque/DD Date:"}
  </b>{" "}
  {mode === "EN"
    ? formatDate(data.dd_date)
    : toMarathiDate(formatDate(data.dd_date))}
</div>
              </div>
            </div>

            <div className="receipt-footer">
              <div className="signature-space"></div>
              {mode === "EN" ? "Slum Rehabilitation Authority / DRP, Mumbai." : "झोपडपट्टी पुनर्वसन प्राधिकरण / डीआरपी, मुंबई."}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DeveloperChargesPrint;